import React from "react";

// Components
import { CheckboxWrapper, Label } from "./Checkbox.styles";
import { Checkbox as CheckboxBase } from "antd";

// Interfaces
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface Props {
  label: string | Function;
  handleOnChange: (checkedValue: CheckboxChangeEvent) => void;
  checked: boolean;
  disabled: boolean;
  minWidth?: string;
  noMargin?: boolean;
  labelColor?: string;
  fontWeight?: number;
}

const Checkbox: React.FC<Props> = ({
  label,
  handleOnChange,
  checked,
  disabled,
  minWidth,
  noMargin,
  labelColor,
  fontWeight,
}) => {
  return (
    <CheckboxWrapper minWidth={minWidth} noMargin={noMargin} disabled={disabled} checked={checked}>
      <CheckboxBase onChange={handleOnChange} checked={checked} disabled={disabled}>
        {typeof label === "string" ? (
          <Label color={labelColor} fontWeight={fontWeight}>
            {label}
          </Label>
        ) : (
          label()
        )}
      </CheckboxBase>
    </CheckboxWrapper>
  );
};

export default Checkbox;
